import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { DescriptionElement } from "./Article";

gsap.registerPlugin(ScrollTrigger);

export const animationLayout = (wrapperRef) => {
    const ref = wrapperRef.current;

    if (!ref) return;

    const articleImgElement = ref.querySelector("img");
    const descriptionElement = ref.querySelector(`${DescriptionElement}`);

    const targets = [articleImgElement, descriptionElement].filter(Boolean);

    if (targets.length === 0) return;

    // Set initial state (elements are already opacity: 0 in CSS)
    gsap.set(targets, { y: 50 });

    // Create scroll trigger
    ScrollTrigger.create({
        trigger: ref,
        start: "top 65%",
        onEnter: () => {
            gsap.to(articleImgElement, {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power2.out",
            });
            gsap.to(descriptionElement, {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.2,
                ease: "power2.out",
            });
        },
    });

    // Fallback: if element is already in view when page loads, animate immediately
    const rect = ref.getBoundingClientRect();
    const isInView = rect.top < window.innerHeight * 0.65;

    if (isInView) {
        gsap.to(articleImgElement, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: "power2.out",
        });
        gsap.to(descriptionElement, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            delay: 0.2,
            ease: "power2.out",
        });
    }
};
